import { getCLS, getFID, getLCP } from 'web-vitals';

import dataLayer from '@rover/globals/dataLayer';

const fireInputDependentPerformanceEvent = async () => {
  let cls;
  getCLS(({ value }) => (cls = value), true); // Update CLS everytime a new value is available, so we have the latest when the page is first interacted with

  const metrics = await Promise.all([
    new Promise(res => getFID(({ value }) => res({ fid: value, cls }))), // Collect both FID and CLS on first input
    new Promise(res => getLCP(({ value }) => res(value))),
  ]);

  const performanceEvent = {
    event: 'input-dependent-performance',
    cumulativeLayoutShift: metrics[0].cls || 0,
    firstInputDelay: metrics[0].fid || 0,
    largestContentfulPaint: metrics[1] || 0,
  };

  dataLayer.push(performanceEvent);
};

window.addEventListener('load', () => fireInputDependentPerformanceEvent());



// WEBPACK FOOTER //
// ./js/core/monitoring/performance.js